import { defineMessage } from 'services/localization';

export const messages = {
    cacheRowOrganisations: defineMessage('organisation'),
    cacheRowItems: defineMessage('items'),
    cacheRowAccounts: defineMessage('accounts'),
    cacheRowTaxRates: defineMessage('taxes'),
    cacheRowTrackingCategories: defineMessage('tracking_categories'),
    cacheRowBranding: defineMessage('themes'),
    cacheRowCurrencies: defineMessage('currencies'),
    cacheRowCounterparties: defineMessage('contacts'),
    inProgressText: defineMessage('in_progress'),
    syncNowText: defineMessage('sync_now'),
    headerText: defineMessage('xero_data_synchronisation_status'),
    fieldCol: defineMessage('field'),
    lastSyncCol: defineMessage('last_synced'),
    syncDurationCol: defineMessage('sync_duration'),
    syncAll: defineMessage('sync_all'),
};
